import {
  downloadFile
} from '@/api/common'
export default {
  data() {
    return {
      isShowExportPopTip: false,
      isExporLoading: false,
      exportArr: []
    }
  },
  methods: {
    changeFormBind(bindForms, item, value) {
      this.bindForms = bindForms
      this.refreshList && this.refreshList()
    },
    // 条件筛选按钮操作
    filterCheckBtn() {
      this.refreshList()
    },
    // 重置按钮操作
    filterResetBtn() {
      this.refreshList()
    },
    // 刷新列表
    refreshList() {
      // 开始请求列表数据
      this.getList()
      // 获取列表总数
      this.getListTotal()
    },
    // 页数改变
    sizeChange(pageSize) {
      this.getList(1, pageSize)
    },
    // 当前页数改变
    currentChange(currentPage) {
      this.getList(currentPage)
    },
    // 时间数组参数处理
    dateParamHandle(valueDate, startKey = 'startTime', endKey = 'endTime') {
      const obj = {}
      if (valueDate && valueDate.length === 2 && typeof valueDate === 'object') {
        obj[startKey] = valueDate[0].trim()
        obj[endKey] = valueDate[1].trim()
      } else if (valueDate && valueDate.length > 0) {
        if (valueDate !== 'define' && valueDate.indexOf('至') < 0) {
          const dates = this.$util.getInitTime(valueDate * 1, 0)
          obj[startKey] = dates.startTime
          obj[endKey] = dates.endTime
        } else if (valueDate.indexOf('至') >= 0) {
          const dates = valueDate.split('至')
          obj[startKey] = dates[0].trim()
          obj[endKey] = dates[1].trim()
        }
      } else {
        obj[startKey] = ''
        obj[endKey] = ''
      }
      return obj
    },
    // 导出数据处理
    exportHandle(result, id, name, isRequired, isCheckBox) {
      const newArr = result.map((item, index) => {
        let children = []
        if (item.children && item.children.length) {
          children = this.exportHandle(item.children, id, name, isRequired, isCheckBox)
        }
        return {
          id: item[id || 'id'] || item.id || index,
          name: item[name || 'name'],
          isRequired: item[isRequired || 'isRequired'] * 1 === 1,
          isCheckBox: item[isRequired || 'isRequired'] * 1 === 1 ? true : (item[isCheckBox || 'isCheckBox'] || false),
          level: item.level || 0,
          children: children || []
        }
      })
      return newArr || []
    },
    // 导出修改
    downloadFile(url, param, exportName, callback) {
      this.isExporLoading = true
      if (!param.userId) param.userId = this.$store.state.userInfo.userId
      downloadFile(url, param, exportName, res => {
        this.isShowExportPopTip = false
        this.isExporLoading = false
        if (res && (res.status * 1 === 200 || res.statusText === 'OK')) {
          this.$message({
            type: 'success',
            message: '导出成功！'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg || '导出失败，请稍后操作！'
          })
        }
        callback && callback(res)
      })
    },
    // 导出按钮点击
    exportBtn() {
      this.isShowExportPopTip = true
    },
    // 导出弹窗删除按钮
    exportCancle() {
      this.isShowExportPopTip = false
    }
  }
}
